<template>
  <div class="app">
    <!-- RACOURCIS -->
    <v-card v-if="userCon.type === 2">
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>
    <!-- STATS BASIC -->
    <div v-if="droitAcces.index_demande_demandeur && userCon.type === 2">
      <v-layout row wrap>
        <v-flex class="mb-5" xs3>
          <v-card-text class="text-xs-center">
            <v-chip  color="primary" text-color="white" class="elevation-8" style="width:100%">
              Demande(s)
              <v-avatar class="indigo">{{totalDmd}}</v-avatar>
            </v-chip>
          </v-card-text>
        </v-flex>
        <v-flex class="mb-5" xs3>
          <v-card-text class="text-xs-center">
            <v-chip  color="orange darken-1" text-color="white" class="elevation-8" style="width:100%">
              En cours de traitement
              <v-avatar class="orange darken-4">{{nbDmdCour}}</v-avatar>
            </v-chip>
          </v-card-text>
        </v-flex>  
        <v-flex class="mb-5" xs3>
          <v-card-text class="text-xs-center">
            <v-chip  color="light-green darken-1" text-color="white" class="elevation-8" style="width:100%">
              Cloturé(s)
              <v-avatar class="light-green darken-4">{{nbDmdclot}}</v-avatar>
            </v-chip>
          </v-card-text>
        </v-flex>  
        <v-flex class="mb-5" xs3> 
          <v-card-text class="text-xs-center">
            <v-chip color="red darken-1" text-color="white" class="elevation-8" style="width:100%">
              Refusé(s)
              <v-avatar class="red darken-4">{{nbDmdRef}}</v-avatar>
            </v-chip>
          </v-card-text>  
        </v-flex>
      </v-layout>    
    </div>

    <p v-else align="center">
      <v-chip text-color="white" label color="red" style="font-size:22px">
        VOUS N'AVIEZ PAS ACCES A CE CONTENU. VEUILLEZ DONC CONTACTER L'ADMINISTRATEUR PRINCIPAL
        <v-icon dark right>stop_screen_share</v-icon>
      </v-chip>
    </p>

    <!-- BTN AJOUT DEMANDE -->
    <div v-if="droitAcces.add_dmd && userCon.type === 2" class="text-xs-right">  
      <v-tooltip top>
        <v-btn  color="primary" slot="activator" @click.stop="newDemande()" dark>Ajouter
          <v-icon dark right>add</v-icon>
        </v-btn>
        <span>Ajouter une nouvelle demande</span>
      </v-tooltip>
    </div>

    <!-- MODAL AJOUT DEMANDE -->
    <v-dialog v-model="dialogAjoutDmd" max-width="80%" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title> 
            <span v-if="dialogEdit !== true">Ajouter une nouvelle demande  <h6 class="caption">{{libzone}}</h6> </span>
            <span v-if="dialogEdit">Modification de la demande {{demandeCourant.ref}} <h6 class="caption"> {{libzone}}</h6> </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutDmd = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formDemande" lazy-validation id="formDemande">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip text-color="white" label color="primary" style="font-size:22px">
                  EFFECTUER UN NOUVELLE DEMANDE
                </v-chip>
              </p>

              <v-layout row justify>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Type de la demande</span>
                    <el-select v-model="selectTypeDemande" placeholder="Type de la demande" style="width: 100%">
                      <el-option v-for="item in typeDemande" :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Nom du demandeur</span>
                    <el-autocomplete v-model="nomPrenDmd" :fetch-suggestions="loadDemandeur" name="nomPrenDmd" placeholder="Nom du demandeur" required style="width: 100%"></el-autocomplete>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Contact 1 du demandeur</span>
                    <el-input v-model="tel1Dmd" name="tel1Dmd" placeholder="Contact 1 du demandeur" required style="width: 100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row justify>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Contact 2 du demandeur</span>
                    <el-input v-model="tel2Dmd" name="tel2Dmd" placeholder="Contact 2 du demandeur" required style="width: 100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Sous zone concerné</span>
                    <el-select filterable v-model="selectSal" placeholder="Sous zone concerné" style="width: 100%">
                      <el-option v-for="item in itemsSal" :key="item.idSalle" :label="item.nomSalle" :value="item.idSalle"></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date d'intervention désiré</span>
                    <el-date-picker v-model="datePrevu" value-format="dd-MM-yyyy" name="datePrevu" type="date" placeholder="Date prévue de l'intervention" style="width: 100%"></el-date-picker>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row justify>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Motif de la demande</span>
                    <el-input type="textarea" :rows="5" v-model="descDmd" name="motif" placeholder="Motif de la demande" required style="width: 100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-btn @click="dialogAjoutDmd = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitDemande" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-container>            
          </v-form>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT NOTE -->
    <v-dialog v-model="dialogAjoutNote" max-width="30%" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title> 
            <span>Donner votre appréciation </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutNote = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formNote" lazy-validation id="formNote">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md12>
                  <p align="center">
                    <el-rate name="note" v-model="noteDemande" :colors="['#99A9BF', '#F7BA2A', '#FF9900']" show-score text-color="red" score-template="{value} points"></el-rate>
                  </p>
                </v-flex>
              </v-layout>
              <v-layout row justify>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Remarque</span>
                    <el-input type="textarea" :rows="5" v-model="descDmd" name="remarque" placeholder="Remarque" required style="width: 100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br>

              <v-btn @click="dialogAjoutNote = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
              <v-btn icons color="blue" @click="submitNote" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            </v-container>            
          </v-form>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TABLEAU LISTANT LES DEMANDES -->
    <v-card v-if="droitAcces.index_demande_demandeur && userCon.type === 2">
      <v-card-title>
        <v-chip text-color="white" label color="primary">LISTE DES DEMANDES DU {{libzone}}</v-chip>
        <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Rechercher" single-line hide-details v-model="search_dmd"></v-text-field>
      </v-card-title>

      <v-data-table v-bind:headers="headers_dmd" v-bind:items="items_dmd" v-bind:search="search_dmd" class="elevation-1" no-data-text="Aucune données" rows-per-page-text="Ligne(s) par page">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.dmdeur }}</td>
          <td class="text-xs-left">
            <v-chip text-color="white" label :color="props.item.color">
              {{ props.item.etat_dmd }} 
            </v-chip>
            <v-chip outline text-color="red" label color="red" v-if='props.item.processus == true'>
              FERMER <v-icon right>clear</v-icon>
            </v-chip>
            <v-chip outline text-color="green" label color="green" v-if='props.item.processus == false'>
              OUVERT <v-icon right>insert_emoticon</v-icon>
            </v-chip>
            <v-chip v-if="props.item.note !== null">
              <el-rate v-model="props.item.note" disabled></el-rate>
            </v-chip>
          </td>
          <td class="text-xs-left">
            <v-chip outline text-color="primary" label color="primary">
              {{ props.item.date_dmd }} 
            </v-chip>
          </td>
          <td class="text-xs-left">
            <div class="text-xs-center">
              <v-tooltip top>
                <v-btn v-if="droitAcces.index_constat" slot="activator" @click.stop="affDetailDmd(props.item)" fab dark small color="green">
                  <v-icon dark>folder_open</v-icon>
                </v-btn>
                Détails
              </v-tooltip>
              <v-tooltip top>
                <v-btn v-if="droitAcces.note_dmd && props.item.etatGlobal === 8 && props.item.processus === true && props.item.note === null" slot="activator" @click.stop="newNote(props.item)" fab dark small color="orange">
                  <v-icon dark>stars</v-icon>
                </v-btn>
                Noté la demande
              </v-tooltip>
              <v-tooltip top>
                <v-btn v-if="droitAcces.add_dmd && props.item.etatGlobal < 2" slot="activator" @click.stop="editDemande(props.item)" fab dark small color="primary">
                  <v-icon dark>edit</v-icon>
                </v-btn>
                Modifier
              </v-tooltip>
            </div>                
          </td>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
           Ligne {{ pageStart }} à {{ pageStop }}
        </template>
      </v-data-table>
    </v-card>

  </div>  
</template>

<script>
   export default {
     name: 'app',
     data() {
       return {
        loading: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        userCon: JSON.parse(sessionStorage.getItem('userInfo')),
        droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
        racourcis: [
          { path: '/', text: 'Accueil', disabled: false },
          { path: '/maintenance', text: 'Maintenance', disabled: false },
          { path: '/', text: 'Liste des demandes', disabled: true }
        ],
        valid: true,
        dialogEdit: false,
        dialogAjoutDmd: false,
        dialogAjoutNote: false,
        id_dmd: null,
        nomPrenDmd: '',
        libzone: '',
        descDmd: '',
        totalDmd: 0,
        nbDmdCour: 0,
        nbDmdclot: 0,
        nbDmdRef: 0,
        msgInfo: 0,
        tel1Dmd: '',
        tel2Dmd: '',
        datePrevu: null,
        salleDmd: null,
        typeMes: 'success',
        msg: '',
        selectSal: null,
        itemsSal: [],
        selectTypeDemande: null,
        typeDemande: [
          { text: 'Réparation', value: 1 },
          { text: 'Fourniture de matériel', value: 2 }
        ],
        tmp: '',
        search_dmd: '',
        headers_dmd: [
          { text: 'Demandeur', value: 'dmdeur', align: 'center' },
          { text: 'Etat', lue: 'etat_dmd', align: 'center' },
          { text: 'Date', value: 'date_dmd', align: 'center' },
          { text: 'Actions', align: 'center' }
        ],
        items_dmd: [],
        demandeCourant: {},
        noteDemande: null
       }
     },
     mounted() {
       this.loadPage()
       this.loadDemande()
     },
     methods: {
      loadPage () {
        const loading = this.$loading({
          lock: true,
          text: 'Veuillez patientez ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 1000)
      },
      loadDemande() {
        let url = this.domaine + 'demande/'+ this.userCon.id +'/liste'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.nbDmdCour = response.body.listNbDmd.encours;
            this.nbDmdclot = response.body.listNbDmd.cloture;
            this.nbDmdRef = response.body.listNbDmd.refuse;
            this.libzone = response.body.libZone
            this.itemsSal = response.body.salle
            this.items_dmd = response.body.listDmd
            this.totalDmd = response.body.listNbDmd.total
          }
        }) 
      },
      loadDemandeur(queryString, cb) {
        let url = this.domaine +  'maintenance/listes-demandeur'
        var formdata = new FormData();
        formdata.append('user', this.userCon.id)
        formdata.append('tag', queryString)
        this.$http.post(url, formdata).then(response => {
          if (response.body) {
            var links = response.body;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            cb(results);
          }
        },
        response => {
        })
      },
      newDemande () {
        this.dialogAjoutDmd = true
        this.dialogEdit = false
        this.id_dmd = ''
        this.nomPrenDmd = ''
        this.selectTypeDemande = null
        this.descDmd = ''
        this.tel1Dmd = ''
        this.tel2Dmd = ''
        this.datePrevu = null
        this.selectSal = null
      },
      newNote (item) {
        this.demandeCourant = item
        this.dialogAjoutNote = true
        this.noteDemande = 0
        this.descDmd = ''
      },
      editDemande (item) {
        this.demandeCourant = item
        this.dialogAjoutDmd = true
        this.dialogEdit = true
        this.id_dmd = item.id_dmd
        this.selectTypeDemande = item.typeDemande
        this.nomPrenDmd = item.dmdeur
        this.descDmd = item.motif
        this.tel1Dmd = item.tel1
        this.tel2Dmd = item.tel2
        this.datePrevu = item.interventionDate
        this.selectSal = item.idSalle
      },
      submitDemande() {
        this.loading = true
        if (this.$refs.formDemande.validate()) {
          if (this.selectTypeDemande !== null && this.selectSal !== null && this.tel1Dmd !== '' && this.descDmd !== "" && this.datePrevu !== null && this.nomPrenDmd !== '') {
            var form = document.getElementById('formDemande')
            var data = new FormData(form)
            let url = this.domaine + 'demande/ajout'
            data.append('id', this.id_dmd)
            data.append('idUser', this.userCon.id)
            data.append('type', this.selectTypeDemande)
            data.append('zone', this.selectSal)

            this.$http.post(url, data).then((response) => {
              if (response.body) {
                let verif = response.body
                if (verif.code === 1) {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Demande enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                  this.loadDemande()
                  this.dialogAjoutDmd = false
                  this.loading = false
                  this.$refs.formDemande.reset()
                } else if (verif.code === 0) {
                  this.$message.error(verif.message)
                  this.loading = false
                }
              } else {
                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                this.loading = false
              }
            }, (response) => {
               this.loading = false;
               this.$message.error("Erreur lors de l'ajout de la demande");
            })
          } else {
            this.$message.error('Veuillez renseigner les champs obligatoires')
          }
        } else {
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La demande n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitNote() {
        this.loading = true
        if (this.$refs.formNote.validate()) {
          if (this.noteDemande !== null) {
            var form = document.getElementById('formNote')
            var data = new FormData(form)
            let url = this.domaine + 'demande/'+this.demandeCourant.id_dmd+'/note'
            data.append('idUser', this.userCon.id)
            data.append('note', this.noteDemande)

            this.$http.post(url, data).then((response) => {
              if (response.body) {
                let verif = response.body
                if (verif.code === 1) {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Note enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                  this.loadDemande()
                  this.dialogAjoutNote = false
                  this.loading = false
                  this.$refs.formNote.reset()
                } else if (verif.code === 0) {
                  this.$message.error(verif.message)
                  this.loading = false
                }
              } else {
                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                this.loading = false
              }
            }, (response) => {
               this.loading = false;
               this.$message.error("Erreur lors de l'ajout de la demande");
            })
          } else {
            this.$message.error('Veuillez renseigner les champs obligatoires')
          }
        } else {
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La note n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      querySearch(queryString, cb) {
        var links = this.liste.devis;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        cb(results);
      },
      createFilter(queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      affDetailDmd(current) {
        this.$router.push({ name: 'DetailDemande', params: { demande_id: current.id_dmd }})
      } 
    },
    beforeMount: function () {
      if(!this.roleAcces[this.$router.history.current.name]){
        this.$router.push({ name: 'Home'  })
      }
    }
   }
</script>




// WEBPACK FOOTER //
// src/components/Demande.vue